import { useEffect, useState } from 'react';

const DEFAULT_DELAY = 500;

// The debounced value will only reflect the latest value when the useDebounce hook has not been called for the specified time period.
export function useDebounce<T>(value: T, delay?: number) {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay || DEFAULT_DELAY);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
